import React, { useContext } from 'react';

import { Dialog, DialogFooter, DirectionalHint, Facepile, IconButton, OverflowButtonType, Persona, PersonaSize, PrimaryButton, Stack, TooltipHost } from "@fluentui/react";
import { useState } from "react";
import { MyContext } from '../../../context';

export function MailPersona({ participants }) {

     const [showFullReceiverDlg, setShowFullReceiverDlg] = React.useState(false);
     const [dialogContentState, setDialogContentState] = React.useState(createDialogStateFor("", []));
	const context = useContext(MyContext);

     const sender = participants.filter(e => e.type === "MailSender").map(toFacepileUsers);
     const receive = participants.filter(e => e.type === "MailReceiver").map(toFacepileUsers);
     const cc = participants.filter(e => e.type === "MailCC").map(toFacepileUsers);
     const bcc = participants.filter(e => e.type === "MailBCC").map(toFacepileUsers);

     const openDlgWith = (title, persons) => {
          setDialogContentState(createDialogStateFor(title, persons))
          setShowFullReceiverDlg(true)
     }

     return <Stack>
          <PersonaGroup title={context.getTranslation("detailContainer", "mailPersonaSender")}>
               <MailParticipants persons={sender} onShowMore={() => openDlgWith(context.getTranslation("detailContainer", "mailPersonaSenderDlgHeader"), sender)} />
          </PersonaGroup>
          <PersonaGroup title={context.getTranslation("detailContainer", "mailPersonaReceiver")}>
               <MailParticipants persons={receive} onShowMore={() => openDlgWith(context.getTranslation("detailContainer", "mailPersonaReceiverDlgHeader"), receive)} />
          </PersonaGroup>
          <PersonaGroup title={context.getTranslation("detailContainer", "mailPersonaCC")} noShow={cc?.length === 0 ?? false}>
               <MailParticipants persons={cc} onShowMore={() => openDlgWith(context.getTranslation("detailContainer", "mailPersonaCCDlgHeader"), cc)} />
          </PersonaGroup>
          <PersonaGroup title={context.getTranslation("detailContainer", "mailPersonaBCC")} noShow={bcc?.length === 0 ?? false}>
               <MailParticipants persons={bcc} onShowMore={() => openDlgWith(context.getTranslation("detailContainer", "mailPersonaBCCDlgHeader"), bcc)} />
          </PersonaGroup>

          <Dialog hidden={!showFullReceiverDlg} onDismiss={e => setShowFullReceiverDlg(false)}
               dialogContentProps={dialogContentState.props} maxWidth="80%">

               <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '25vh',
                    minWidth: '25vw'
               }}>
                    <div className='mail-receiver-dlg-grid' >
                         <span></span>
                         <span>{context.getTranslation("detailContainer", "mailPersonaDlgName")}</span>
                         <span>{context.getTranslation("detailContainer", "mailPersonaDlgMail")}</span>
                         {dialogContentState.persons.map((e, i) =>
                              [
                                   (<Persona imageUrl={e.imageUrl} text={e.personaName}
                                        hidePersonaDetails={true} // Only show coin  
                                        size={PersonaSize.size32}
                                        title={e.personaName}
                                        key={"person_" + i + "icon"}
                                   />),
                                   (<span key={"person_" + i + "name"}>{e.planeName}</span>),
                                   (<span key={"person_" + i + "mail"}>{e.planeMail}</span>)
                              ]
                         )}
                    </div>
                    <div style={{ marginTop: 'auto' }}>
                         <DialogFooter>
                              <PrimaryButton onClick={e => setShowFullReceiverDlg(false)} text={context.getTranslation("detailContainer","mailPersonaDlgClose")} />
                         </DialogFooter>
                    </div>
               </div>
          </Dialog>
     </Stack>
}

function createDialogStateFor(title, persons) {
     return {
          props: {
               title: title,
          },
          persons: persons
     }
}


function MailParticipants({ persons, onShowMore }) {
     const overflowButtonProps = {
          ariaLabel: 'More users',
          onClick: (ev => onShowMore()),
     };

     if (persons.length == 0) {
          return null;
     }

     if (persons.length == 1) {
          const singlePerson = persons[0]
          return (
               <Persona imageUrl={singlePerson.imageUrl} text={singlePerson.personaName}
                    hidePersonaDetails={true} // Only show coin  
                    size={PersonaSize.size32}
                    title={singlePerson.personaName}
               />
          )
     }

     return <Facepile personas={persons} overflowButtonType={OverflowButtonType.descriptive} maxDisplayablePersonas={5}
          overflowButtonProps={overflowButtonProps} showInitialsUntilHover={true} />
}

function toFacepileUsers(user) {
     const name = user.name ? user.name + " (" + user.email + ")" : user.email;
     return {
          personaName: name,
          planeName: user.name,
          planeMail: user.email,
          imageUrl: "data:image/jpeg;base64," + user.photo
     }
}

function PersonaGroup({ title, children, noShow }) {
     if (noShow) {
          return null;
     }
     return (
          <Stack>
               <span style={{ fontWeight: 600 }}>{title}</span>
               <Stack styles={{ root: { marginLeft: 32, marginTop: 8 } }}>
                    {children}
               </Stack>
          </Stack>
     );
};